import axiosInstance from '../../../../services/axios/axios';
import { WrapImsPacket } from '../../../../store/utility';

export const queryForDepartmentNames = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/QueryDepartmentNames/' + value)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const queryForBusinessUnits = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/QueryBusinessUnits', {
				params: { businessUnit: value },
			})
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(() => {
				reject(results);
			});
	});
};

export const queryForCostCenters = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/QueryCostCenters/' + value)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const getHospitals = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/GetHospitals')
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};
export const getCountries = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/GetCountries')
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const getStates = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/GetStates/' + value)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const getDepartments = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/GetDepartments/' + value)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const getBusinessUnitFromCostCenter = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/GetBusinesUnitFromCostCenter/' + value)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const getNonEmployeeUserTypes = async val => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetNonEmployeeUserTypes`
		);
		return response.data.payload;
	} catch (ex) {
		console.error('Unable to fetch: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

export const getNonEmployeeUserSubtypes = async val => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetNonEmployeeUserSubtypes/${val}`
		);
		return response.data.payload;
	} catch (ex) {
		console.error('Unable to fetch: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

export const getStudentColleges = async val => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetStudentColleges`
		);
		return response.data.payload;
	} catch (ex) {
		console.error('Unable to fetch: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

export const getUserData = async id => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetUserInfo/${id}`
		);
		return response.data.payload;
	} catch (ex) {
		console.error('Unable to fetch: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

export const getUserRoles = async id => { 
	try {
		const response = await axiosInstance.get(`api/Utilities/Security/Roles/${id}/Users`);
		return response.data.payload;
	} catch (ex) {
		console.error('Unable to fetch: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		}
	}
};

export const addUserRoles = async (id, esoFiId) => {
	try {
		const response = axiosInstance.post(`api/Utilities/Security/Roles/${id}/Users/${esoFiId}`);
		return response;
	} catch (ex) {
		console.error('Unable to validate: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	};
}

export const deleteUserRoles = async (id, esoFiId) => {
	try {
		const response = axiosInstance.delete(`api/Utilities/Security/Roles/${id}/Users/${esoFiId}`);
		return response;
	} catch (ex) {
		console.error('Unable to validate: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	};
}

export const getNonEmployeeJobTitles = value => {
	let results = [];
	return new Promise((resolve, reject) => {
		axiosInstance
			.get('/api/UserAccessReview/GetNonEmployeeJobTitles')
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									results = data;
									break;
								default:
									results = [];
									break;
							}
						}
						break;
					default:
						results = [];
						break;
				}
				resolve(results);
			})
			.catch(errors => {
				reject(results);
			});
	});
};

export const validateManagersEmail = async args => {
	try {
		const response = await axiosInstance.post(
			`/api/UserAccessReview/Validate/ManagerEmail`,
			WrapImsPacket(args)
		);
		return response;
	} catch (ex) {
		console.error('Unable to validate: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

export const validateAccountCoordinatorEmail = async args => {
	try {
		const response = await axiosInstance.post(
			`/api/UserAccessReview/Validate/AccountCoordinatorEmail`,
			WrapImsPacket(args)
		);
		return response;
	} catch (ex) {
		console.error('Unable to validate: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

export const UpdateUserInfo = async args => {
	try {
		const response = await axiosInstance.post(
			`/api/UserAccessReview/UpdateUserInfo`,
			WrapImsPacket(args)
		);
		return response;
	} catch (ex) {
		console.error('Unable to validate: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};


export const getYesNoOptions = () => ['Yes', 'No'];

export const getStudyTypes = () => ['UPMC', 'University of Pittsburgh'];

